import { ApiClient, ApiClientConfig } from "../api-client";
import schemaValidators from "./schema-validators";
import { ApiClientError } from "../errors";

export default class InstallationClient extends ApiClient<typeof schemaValidators> {
	constructor(config: ApiClientConfig) {
		super(config, schemaValidators);
	}

	async createInstallation(systemInfo: { fingerprint: string }) {
		try {
			const response = await super.fetch(`${this.config.verityOrigin}/api/verity/installation`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(systemInfo),
			});
			if (response.ok) {
				const obj: unknown = await response.json();
				if (this.schemaValidators.installation.validate(obj)) {
					return obj;
				}
			}
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	}

	async updateInstallation(id: string, systemInfo: { fingerprint?: string }) {
		try {
			const response = await super.fetch(`${this.config.verityOrigin}/api/verity/installation/${id}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(systemInfo),
			});
			if (response.ok) {
				const obj: unknown = await response.json();
				if (this.schemaValidators.installation.validate(obj)) {
					return obj;
				}
			}
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	}
}
